import $ from 'jquery';
import './form-validation-boilerplate';
$(function () {
  var $form = $('.form');
  var $resetButton = $('.form__reset-button');
  var $thankyou = $('#sign-up-thank-you');
  if ($thankyou && $thankyou.length) {
    scrollToThankYou();
  }
  $form.on('submit', checkErrors);
  $resetButton.on('click touch', resetForm);
  function checkErrors() {
    var $errorsWrapper = $form.find('.validation-summary-errors');
    var $errors = $errorsWrapper.find('li');
    if ($errors && $errors.length) {
      $errorsWrapper.addClass('invalid');
    } else {
      $errorsWrapper.removeClass('invalid');
    }
  }
  function resetForm() {
    window.location.reload(true);
  }
  function scrollToThankYou() {
    var scrollTop = $thankyou.offset().top;
    console.log('scrollTop', scrollTop);
    $('html, body').animate({
      scrollTop: scrollTop
    }, 'fast');
  }
});